export const backendHostName = process.env
  .NEXT_PUBLIC_BACKEND_HOSTNAME as unknown as string;

export const googleMapsApiKey = process.env
  .NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as unknown as string;

export const googleMapsId = process.env
  .NEXT_PUBLIC_GOOGLE_MAP_ID as unknown as string;

// Fallback view state in case initial map state fetch fails
// Uses Geneva coordinates at a different zoom than the backend seed (16) to verify the API call works
export const fallbackViewState = { latitude: 46.21, longitude: 6.13, zoom: 14 };
